import { render, staticRenderFns } from "./ChipsBar.vue?vue&type=template&id=630c3616&scoped=true"
import script from "./ChipsBar.vue?vue&type=script&lang=js"
export * from "./ChipsBar.vue?vue&type=script&lang=js"
import style0 from "./ChipsBar.vue?vue&type=style&index=0&id=630c3616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630c3616",
  null
  
)

export default component.exports